import { createFileRoute } from '@tanstack/react-router';
import { VerifyEmailPage } from '../components/auth/VerifyEmailPage';

export const Route = createFileRoute('/verify-email')({
  validateSearch: (search: Record<string, unknown>) => {
    return {
      email: (search.email as string) || undefined,
    };
  },
  component: VerifyEmail,
});

function VerifyEmail() {
  return <VerifyEmailPage />;
}
